import { Button, Icon, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useCreateAutomationModal } from '@hero/hooks';

import * as S from './style';

function EmptyAutomationTable() {
  const { t } = useTranslation();
  const { showCreateAutomationModal } = useCreateAutomationModal();

  return (
    <S.EmptyTableWrapper>
      <Icon name="automation" color="var(--color-accent-primary-default)" size="xxl" />
      <Typography variant="body2SemiBold">
        {t('emptyTableTitle1', { feature: 'automation' })}
      </Typography>
      <Button startIcon={<Icon name="add" />} onClick={showCreateAutomationModal}>
        {t('createNew')}
      </Button>
    </S.EmptyTableWrapper>
  );
}

export { EmptyAutomationTable };
